__turbopack_context__.v({
  "className": "dm_mono_9a64022e-module__R3zStq__className",
});
